export default __webpack_public_path__ + "static/media/Primary-Raw.6fe3d55e.svg";